import constants from './plugins/constants'
import { Notification } from 'uiv'

function mixOptions (options) {
  return Object.assign(
    {},
    {
      placement: constants.NOTIFICATION_PLACEMENT
    },
    options
  )
}

function notifyError (options) {
  Notification.notify.error(mixOptions(options))
}

function notifySuccess (options) {
  Notification.notify.success(mixOptions(options))
}

export default {
  notifyError,
  notifySuccess
}
